import { Injectable } from '@angular/core';
import { subjectFromObs } from 'core/rx-js';
import { debounceTime, fromEvent, map, startWith } from 'rxjs';
import { ScreenSize } from './types/screen-size';

export type LSCreenSize = 'xl' | 'lg' | 'md' | 'sm' | 'xs'

@Injectable({
  providedIn: 'root'
})
export class ScreenUtilsService {

  readonly screenSizes: Record<LSCreenSize, number> = {
    xl: 1900,
    lg: 1300,
    md: 800,
    sm: 600,
    xs: 0
  }

  private readonly _screenSizeObs = fromEvent(window, 'resize')
    .pipe(
      debounceTime(100),
      map(() => window.innerWidth),
      startWith(window.innerWidth),
      map((width): ScreenSize => this._calculateScreenSize(width))
    )

  readonly screenSizeSubject = subjectFromObs<ScreenSize>({
    observable: this._screenSizeObs,
    initialValue: this._calculateScreenSize(window.innerWidth)
  })


  readonly isSmallerScreenObs = this.screenSizeSubject.pipe(
    map((screenSize) => screenSize === 'xs' || screenSize === 'sm')
  )

  readonly isLargeScreenObs = this.screenSizeSubject.pipe(
    map((screenSize) => screenSize === 'xl' || screenSize === 'lg')
  )

  get isSmallerScreen() {
    const screenSize = this.screenSizeSubject.value;
    return screenSize === 'xs' || screenSize === 'sm'
  }


  constructor() { }

  private _calculateScreenSize(width: number) {

    const [key] = Object.entries(this.screenSizes)
      .sort(([, first], [, second]) => second - first)
      .find(([, value]) => width >= value);

    return key as ScreenSize
  }
}
